function parseDate(str) {
  const [dateparts, timeparts] = str.split(" ");
  const [year, month, day] = dateparts.split("-");
  const [hours = 0, minutes = 0, seconds = 0] = timeparts?.split(":") ?? [];
  // Treats the string as UTC, but you can remove the `Date.UTC` part and use
  // `new Date` directly to treat the string as local time
  return new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
}

// 从entity中的display或者properties中获取数据
export function display(entity, fieldName) {
  if (!entity) {
    return ''
  }
  if (entity.$displays[fieldName]) {
    return entity.$displays[fieldName];
  } else {
    return entity.properties[fieldName];
  }
}

export function hideCode(code) {
  if (!code) {
    return
  }
  var changeStr = function (allstr, start, end, changeStr) {
    return allstr.substring(0, start - 1) + changeStr + allstr.substring(end, allstr.length);
  }
  var hideCode = changeStr(code, 6, 14, '********');
  return hideCode
}

export function splitByLength(str, targetLength) {
  if (str) {
    const arr = []
    for (var i = 0, length = str.length; i < length / targetLength; i++) {
      var a = str.slice(targetLength * i, targetLength * (i + 1));
      arr.push(a);
    }
    return arr.join('-')
  } else {
    return ''
  }
}

export function fullDate(date) {
  const dateObj = new Date(date)
  const output = `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()} ${dateObj.toLocaleTimeString()}`
  return output
}

export function chineseDate(date) {
  if (typeof date === 'string') {
    const dateObj = parseDate(date);
    return `${dateObj.getFullYear()}年${dateObj.getMonth() + 1}月${dateObj.getDate()}日`
  } else if (typeof date === 'number') {
    const dateObj = new Date(date)
    return `${dateObj.getFullYear()}年${dateObj.getMonth() + 1}月${dateObj.getDate()}日`
  } else {
    return ''
  }
}
